module.exports = __webpack_public_path__ + "static/media/cucina_moderno.a6f3f626.jpg";